import(/* webpackMode: "eager", webpackExports: ["ButtonScrollTo"] */ "/vercel/path0/components/ButtonScrollTo.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ContentfulImage/ContentfulImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Carousel","CarouselContent","CarouselItem","CarouselPrevious","CarouselNext"] */ "/vercel/path0/components/ui/carousel.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next-view-transitions@0.2.0_next@14.2.3_react-dom@18.3.1_react@18.3.1__react@18.3.1__react-do_irlwflvwzlcm6ysqgo3lbdtseq/node_modules/next-view-transitions/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@14.2.3_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
